import type { CatalogReducerHandler } from './';

export const catalogReducer: CatalogReducerHandler = (state, action) => {
  switch (action.type) {
    case 'UPDATE_SELECTED_CATEGORY':
      return {
        ...state,
        selectedCategory: action.payload,
      };
    case 'CLEAN_SELECTED_CATEGORY':
      return {
        ...state,
        selectedCategory: null,
      };

    case 'HIDE_SIDEBARNAV_MOBILE':
      return {
        ...state,
        isSidebarNavMobileOpen: false,
      };
    case 'TOGGLE_SIDEBARNAV_MOBILE':
      return {
        ...state,
        isSidebarNavMobileOpen: !state.isSidebarNavMobileOpen,
      };

    default:
      return state;
  }
};
export default catalogReducer;
